import { render, staticRenderFns } from "./ManageWorkers.vue?vue&type=template&id=09c2c6e5&"
import script from "./ManageWorkers.vue?vue&type=script&lang=js&"
export * from "./ManageWorkers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports